import { render, staticRenderFns } from "./ContentMain.vue?vue&type=template&id=2792a32e"
import script from "./ContentMain.vue?vue&type=script&lang=js"
export * from "./ContentMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports